/**
 * RoomCreateScreen — crea una stanza (tipo, cap, TTL, soprannome). Dopo la
 * creazione porta direttamente alla chat, dove il creatore può invitare.
 */
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Frame, Header, Footer, Btn, Box, FieldLabel, Input } from '../components/Frame';
import { useStore } from '../lib/store';
import { createRoom } from '../lib/rooms';

const TTL = [
  { v: 3600, l: '1 ora' }, { v: 21600, l: '6 ore' }, { v: 86400, l: '24 ore' },
  { v: 259200, l: '3 giorni' }, { v: 604800, l: '7 giorni (max)' },
];

export default function RoomCreateScreen() {
  const navigate = useNavigate();
  const { mnemonic } = useStore();
  const [cap, setCap] = useState(5);
  const [ttl, setTtl] = useState(86400);
  const [nickname, setNickname] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);

  const capMax = 10;

  async function onCreate() {
    setErr(null); setBusy(true);
    try {
      const memberCap = Math.min(Math.max(Number(cap) || 2, 2), capMax);
      const { roomId } = await createRoom({
        mnemonic, type: 'work', memberCap, ttlSeconds: ttl,
        nickname: nickname.trim() || undefined,
      });
      navigate(`/room/${roomId}`, { replace: true });
    } catch (e) { setErr(e.message); setBusy(false); }
  }

  return (
    <Frame statusLeft="NUOVA STANZA" statusRight="">
      <Header title="// Crea stanza" crumb="◀ indietro" onCrumbClick={() => navigate(-1)} />
      <div className="space-y-4">
        <Box className="text-[13px] text-ink-dim leading-relaxed">
          Una stanza è uno <b className="text-ink">strumento pratico</b> per parlare con
          più tuoi contatti insieme (es. avvocato + commercialista). Puoi invitare
          <b className="text-ink"> solo persone già nei tuoi contatti approvati</b> — nessuno
          sconosciuto. Si autodistrugge quando la bruci tu o allo scadere del tempo.
        </Box>
        <div>
          <FieldLabel>Partecipanti max (2–{capMax})</FieldLabel>
          <Input type="number" min={2} max={capMax} value={cap} onChange={(e) => setCap(e.target.value)} />
        </div>
        <div>
          <FieldLabel>Si autodistrugge entro</FieldLabel>
          <select value={ttl} onChange={(e) => setTtl(Number(e.target.value))}
            className="w-full bg-black border border-ink-dim rounded-lg text-ink font-mono text-[15px] py-2.5 px-3">
            {TTL.map((o) => <option key={o.v} value={o.v}>{o.l}</option>)}
          </select>
        </div>
        <div>
          <FieldLabel>Il tuo soprannome nella stanza (opz.)</FieldLabel>
          <Input value={nickname} onChange={(e) => setNickname(e.target.value)} maxLength={24} placeholder="es. blackbird" />
        </div>
        <Box variant="warn" className="text-[13px]">
          🎭 Entri con un'identità <b>usa-e-getta</b>. ⚠️ In gruppo l'effimero è <b>più debole</b>: chiunque può fare uno screenshot.
        </Box>
        {err && <Box variant="danger" className="text-[14px] text-red-400">{err}</Box>}
      </div>
      <Footer>
        <Btn variant="primary" onClick={onCreate} disabled={busy}>{busy ? 'creazione…' : 'Crea stanza'}</Btn>
      </Footer>
    </Frame>
  );
}
